module.exports = __webpack_public_path__ + "img/tooltip-arrow.3aaaed90.svg";